<ng-template #content_batch_pricing let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.product_config">
        <div class="side_popup_header">
            <span>{{localService.languageContent.product_config.pricing_details}}</span>
            <span
                *ngIf="priceInitialization && priceInitialization.detail.productId">&nbsp;-&nbsp;{{priceInitialization.detail.productName}}</span>
            <span class="en" *ngIf="priceInitialization && priceInitialization.detail.batchId"
                style="font-style: italic;">&nbsp;({{priceInitialization.detail.batchName}})</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" [ngStyle]="{'max-height' : localService.sideBarBodyHeight + 'px'}"
            *ngIf="priceInitialization">
            <div *ngIf="isShowDeleteConfirmation" class="box">
                <app-message-box [message]="localService.languageContent.common.need_confirmation_message"
                    [IsConfirmationType]="true" (onClose)="onCloseMessageBox($event)"></app-message-box>
            </div>
            <div class="row" *ngIf="!priceInitialization.detail.isExistingDataAvailable">
                <div class="col-12" style="text-align: center;">
                    <button type="button" class="btn btn-primary" [id]="elementIds.bring_primary_price"
                        (click)="onAction(1)">{{localService.languageContent.product_config.bring_from_primary}}</button>
                </div>
            </div>
            <div *ngIf="!isShowDeleteConfirmation">
                <app-pricing-container [(items)]="priceInitialization.pricings" [isNotConsiderTax]="isNotConsiderTax"
                    [businessTaxes]="priceInitialization.businessTaxesFull" [navigateToNextId]="elementIds.save_product"
                    [isShowLabel]="false" [businessTaxCategories]="priceInitialization.detail.businessTaxCategories"
                    [selectedBusinessTaxCategoryId]="priceInitialization.detail.selectedTaxCategoryId" [isEnableTaxCategory]="false">
                </app-pricing-container>
            </div>
            <div *ngIf="!isShowDeleteConfirmation && isExcludePrice">
                <app-label [Text]="localService.languageContent.product_config.excluded" />
            </div>
            <div *ngIf="!isShowDeleteConfirmation && isExcludePrice">
                <app-pricing-container [(items)]="priceInitialization.pricingsExcluded" [isNotConsiderTax]="true"
                    [businessTaxes]="priceInitialization.businessTaxesFull" [isExcluded]="true" [isShowLabel]="false"
                    [businessTaxCategories]="priceInitialization.detail.businessTaxCategories"
                    [selectedBusinessTaxCategoryId]="priceInitialization.detail.selectedTaxCategoryId" [isEnableTaxCategory]="false">
                </app-pricing-container>
            </div>
        </div>
        <div class="side_popup_footer" *ngIf="priceInitialization && !isShowDeleteConfirmation">
            <div class="row">
                <div class="col-6" style="text-align: left;">
                    <button type="button" class="btn btn-primary" [id]="elementIds.btn_delete_pricing"
                        *ngIf="priceInitialization.detail.isExistingDataAvailable"
                        style="background-color: red !important;"
                        (click)="onAction(3)">{{localService.languageContent.common.delete}}</button>
                </div>
                <div class="col-6" style="text-align: right;">
                    <button type="button" class="btn btn-primary" [id]="elementIds.save_product"
                        (click)="onAction(2)">{{priceInitialization.detail.isExistingDataAvailable ?
                        localService.languageContent.common.update :
                        localService.languageContent.common.create}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>